import { Auth0Error, Auth0UserProfile } from "auth0-js";

enum TypeKeys {
    NAVIGATE_TO_LOGIN = "NAVIGATE_TO_LOGIN",
    NAVIGATE_TO_LOGIN_ERROR = "NAVIGATE_TO_LOGIN_ERROR",
    DO_AUTHENTICATION = "DO_AUTHENTICATION",
    DO_AUTHENTICATION_SUCCESS = "DO_AUTHENTICATION_SUCCESS",
    DO_AUTHENTICATION_ERROR = "DO_AUTHENTICATION_ERROR",
    LOGOUT_REQUEST = "LOGOUT_REQUEST",
    LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
    LOGOUT_ERROR = "LOGOUT_ERROR",
    RENEW_TOKEN = "RENEW_TOKEN",
    RENEW_TOKEN_SUCCESS = "RENEW_TOKEN_SUCCESS",
    RENEW_TOKEN_ERROR = "RENEW_TOKEN_ERROR",
}

export interface NavigateToLogin {
    type: TypeKeys.NAVIGATE_TO_LOGIN;
}

export interface DoAuthentication {
    type: TypeKeys.DO_AUTHENTICATION;
}

export interface DoAuthenticationError {
    type: TypeKeys.DO_AUTHENTICATION_ERROR;
    error: Auth0Error;
}

export interface DoAuthenticationSuccess {
    type: TypeKeys.DO_AUTHENTICATION_SUCCESS;
    profile: Auth0UserProfile;
    accessToken: string;
    expireDate: Date;
}

export interface NavigateToLoginError {
    type: TypeKeys.NAVIGATE_TO_LOGIN_ERROR;
    error: any;
}

export interface RequestLogout {
    type: TypeKeys.LOGOUT_REQUEST;
}

export interface ReceiveLogout {
    type: TypeKeys.LOGOUT_SUCCESS;
    profile: any;
    accessToken: null;
}

export interface RenewToken {
    type: TypeKeys.RENEW_TOKEN;
}

export interface RenewTokenError {
    type: TypeKeys.RENEW_TOKEN_ERROR;
    error: Auth0Error;
}

export interface RenewTokenSuccess {
    type: TypeKeys.RENEW_TOKEN_SUCCESS;
    accessToken: string;
}

export type LoginAction = NavigateToLogin | NavigateToLoginError |
DoAuthentication | DoAuthenticationError | DoAuthenticationSuccess;
export type LogoutAction = RequestLogout | ReceiveLogout;
export type TokenAction = RenewToken | RenewTokenSuccess | RenewTokenError;
export type AuthAction = LoginAction | LogoutAction | TokenAction;

export default TypeKeys;
